// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Yk-z","tupacHeader":"Zk-z","tupacHeader2":"_k-z","tupacMenu":"al-z","tupacMenu2":"bl-z","tupacMain":"cl-z","tupacMain2":"dl-z"};